module.exports = __webpack_public_path__ + "static/img/v5.fe21895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/v5.jpg
// module id = u9Ob
// module chunks = 1